import React from 'react'
import { CrossIcon, Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_3 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "3")
  const title = statusContent.titleText || 'ไม่ผ่านการคัดเลือก'
  const body = statusContent.bodyText || ''

  return (
    <>
      <Pane
        color="#ffffff"
        backgroundColor="#ff0000"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={8}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" fontWeight={700}>
          <CrossIcon /> {title}
        </Text>
      </Pane>
      {body ? (
        <Pane
          color="#000000"
          backgroundColor="#686868"
          height="100%"
          paddingY={4}
          paddingX={5}
          fontSize={16}
          fontFamily=""
          fontWeight={700}
          marginBottom={8}
          display="flex" alignItems="center" justifyContent="center"
        >
          <Text color="#ffffff" fontWeight={700}>
            {body}
          </Text>
        </Pane>
      ) : null}
    </>
  )
}

export default StatusRegister_3
